/** @graphql agg **/
import gql from 'graphql-tag';

import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient.ts';

import {
	type fetchNativeCollabAGGUsersQuery as UsersQuery$data,
	type fetchNativeCollabAGGUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchNativeCollabAGGUsersQuery.ts';

export const fetchNativeCollabAGGUsers = (accountIds: string[]) => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return getAGGClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchNativeCollabAGGUsersQuery($accountIds: [ID!]!) {
					users(accountIds: $accountIds) {
						accountId
						name
						picture
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.users
					?.filter((user) => user?.accountId)
					.map((user) => ({
						avatar: user.picture ?? '',
						email: '',
						name: user.name ?? '',
						userId: user.accountId,
					})) ?? []
			);
		});
};
